/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable camelcase */
/* eslint-disable @stylistic/max-len */
import React, { useEffect, useState } from "react";
import apiCalls from "../PowerShadesAPIFunctions";
import {
	FabricDisallowedCountrySubdivisionsViewModel,
	GetFabricsAndTheirDisallowedCountrySubdivisions
} from "../powershadesApiTypes";
import Button from "../Parts/Button";

const FabricDisallowedByStateContent = () => {
	// Columns:
	// Select
	// Fabric Name
	// States Count
	// Actions ( Edit, Clear, View States)

	const [fabricDisallowances, setFabricDisallowances] = useState<GetFabricsAndTheirDisallowedCountrySubdivisions | null>(null);
	const [selectedFabrics, setSelectedFabrics] = useState<string[]>([]); // fabric_name[]
	// removed unused massAction state
	const [showEditModal, setShowEditModal] = useState<{ fabric: FabricDisallowedCountrySubdivisionsViewModel | null, show: boolean }>({ fabric: null, show: false });
	const [showViewModal, setShowViewModal] = useState<{ fabric: FabricDisallowedCountrySubdivisionsViewModel | null, show: boolean }>({ fabric: null, show: false });
	const [showClearModal, setShowClearModal] = useState<{ fabric: FabricDisallowedCountrySubdivisionsViewModel | null, show: boolean }>({ fabric: null, show: false });
	const [showMassDisallowModal, setShowMassDisallowModal] = useState(false);
	const [showMassClearModal, setShowMassClearModal] = useState(false);
	const [editShowAllCountries, setEditShowAllCountries] = useState(false);
	const [editSubdivisions, setEditSubdivisions] = useState<number[]>([]);
	const [massDisallowSubdivisions, setMassDisallowSubdivisions] = useState<number[]>([]);
	const [countrySubDivisionSearch, setCountrySubDivisionSearch] = useState<string>("");
	const [fabricSearch, setFabricSearch] = useState<string>("");

	const getAndSetData = () => {
		apiCalls.getFabricDisallowedCountrySubdivisions().then((response) => {
			setFabricDisallowances(response.data);
		});
	};

	useEffect(() => {
		getAndSetData();
	}, []);

	if (!fabricDisallowances) return <div>Loading...</div>;

	const { fabric_disallowed_country_subdivisions, country_subdivisions } = fabricDisallowances;
	const filteredFabricDisallowedCountrySubdivisions = fabricSearch.trim() === "" ? fabric_disallowed_country_subdivisions : fabric_disallowed_country_subdivisions.filter((f) => f.fabric_name.toLowerCase().includes(fabricSearch.toLowerCase()));
	const sortedAndFilteredFabrics = filteredFabricDisallowedCountrySubdivisions.sort((a, b) => a.fabric_name.localeCompare(b.fabric_name));
	const filteredCountrySubdivisions = countrySubDivisionSearch === "" ? country_subdivisions : country_subdivisions.filter((cs) => cs.name?.toLowerCase().includes(countrySubDivisionSearch.toLowerCase()) ?? false);

	const getSubdivisionName = (id: number) => country_subdivisions.find((cs) => cs.id === id)?.name || id;
	const getSubdivisionCountry = (id: number) => country_subdivisions.find((cs) => cs.id === id)?.country_code || "";

	// --- Table Row Select ---
	const handleSelectFabric = (fabric: string, checked: boolean) => {
		setSelectedFabrics((prev) => (checked ? [...prev, fabric] : prev.filter((f) => f !== fabric)));
	};
	const allSelected = filteredFabricDisallowedCountrySubdivisions.length > 0 && selectedFabrics.length === filteredFabricDisallowedCountrySubdivisions.length;
	const handleSelectAll = (checked: boolean) => {
		setSelectedFabrics(checked ? filteredFabricDisallowedCountrySubdivisions.map((f) => f.fabric_name) : []);
	};

	// --- Per Fabric Actions ---
	const openEditModal = (fabric: FabricDisallowedCountrySubdivisionsViewModel) => {
		setEditShowAllCountries(false);
		setEditSubdivisions(fabric.disallowed_country_subdivision_ids);
		setShowEditModal({ fabric, show: true });
	};
	const openViewModal = (fabric: FabricDisallowedCountrySubdivisionsViewModel) => {
		setShowViewModal({ fabric, show: true });
	};
	const openClearModal = (fabric: FabricDisallowedCountrySubdivisionsViewModel) => {
		setShowClearModal({ fabric, show: true });
	};

	// --- Mass Actions ---
	const openMassDisallowModal = () => {
		setMassDisallowSubdivisions([]);
		setShowMassDisallowModal(true);
	};
	const openMassClearModal = () => {
		setShowMassClearModal(true);
	};

	const clearFabricDisallowances = (fabricIds: number[]) => {
		apiCalls.clearFabricDisallowedCountrySubdivisions(fabricIds).then(() => {
			getAndSetData();
		});
	};

	const assignStatesToFabricDisallowances = (fabricNames: string[], subdivisionIds: number[]) => {
		const dateToSendForUpdate = fabricNames.map((name) => {
			const fabricId = filteredFabricDisallowedCountrySubdivisions.find((f) => f.fabric_name === name)?.fabric_id ?? 0;
			return {
				fabric_id: fabricId,
				fabric_name: name,
				disallowed_country_subdivision_ids: subdivisionIds
			};
		});
		apiCalls.updateFabricDisallowedCountrySubdivisions(dateToSendForUpdate).then(() => {
			getAndSetData();
		});
	};

	const clearFabricsSelected = () => {
		const fabricIds = selectedFabrics.map((fName) => filteredFabricDisallowedCountrySubdivisions.find((f) => f.fabric_name === fName)?.fabric_id ?? 0);

		clearFabricDisallowances(fabricIds);
	};

	// --- Render ---
	return (
		<div>
			<div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
				<Button size="sm" color="light" className="rounded px-2 py-1" disabled={selectedFabrics.length === 0} onClick={openMassDisallowModal}>Mass Disallow</Button>
				<Button size="sm" color="light" className="rounded px-2 py-1" disabled={selectedFabrics.length === 0} onClick={openMassClearModal}>Mass Clear</Button>
			</div>
			<table className="custom-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
				<thead>
					<tr>
						<th><input type="checkbox" checked={allSelected} onChange={(e) => handleSelectAll(e.target.checked)} /></th>
						<th>Fabric Name</th>
						<th># Subdivisions Disallowed</th>
						<th>Actions</th>
					</tr>
					<tr key="search-row">
						<th/>
						<th>
							<input
								type="text"
								placeholder="Search Fabrics"
								value={fabricSearch}
								onChange={(e) => setFabricSearch(e.target.value)}
								style={{ width: '100%' }}
							/>
						</th>
						<th/>
						<th/>
					</tr>
				</thead>
				<tbody>
					{sortedAndFilteredFabrics.map((fabric) => (
						<tr key={`${fabric.fabric_name}-${fabric.fabric_id}`}>
							<td><input type="checkbox" checked={selectedFabrics.includes(fabric.fabric_name)} onChange={(e) => handleSelectFabric(fabric.fabric_name, e.target.checked)} /></td>
							<td>{fabric.fabric_name}</td>
							<td>{fabric.disallowed_country_subdivision_ids.length}</td>
							<td style={{ display: 'flex', gap: 2 }}>
								<Button
									title="Edit"
									size="sm"
									color="light"
									className="rounded px-2 py-1"
									onClick={() => openEditModal(fabric)}
								>
									Edit
								</Button>
								<Button
									title="View"
									size="sm"
									color="light"
									className="rounded px-2 py-1"
									onClick={() => openViewModal(fabric)}
								>
									View
								</Button>
								<Button
									title="Clear"
									size="sm"
									color="light"
									className="rounded px-2 py-1"
									onClick={() => openClearModal(fabric)}
								>
									Clear
								</Button>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			{/* Edit Modal */}
			{showEditModal.show && showEditModal.fabric && (
				<div className="modal-holder">
					<div className="standard-modal">
						<h3>
							Edit Disallowed Subdivisions for &quot;
							{showEditModal.fabric.fabric_name}
							&quot;
						</h3>
						<Button size="sm" color="light" className="rounded px-2 py-1" onClick={() => setEditShowAllCountries((e) => !e)}>
							{editShowAllCountries ? 'Show Only USA States' : 'Show All Countries'}
						</Button>
						<div style={{ maxHeight: 300, overflowY: 'auto', margin: '12px 0' }}>
							<table style={{ width: '100%' }}>
								<thead>
									<tr>
										<th />
										<th>Name</th>
										<th>Country</th>
									</tr>
								</thead>
								<tr key="search-row">
										<td/>
										<td>
											<input
												type="text"
												placeholder="Search Subdivisions"
												value={countrySubDivisionSearch}
												onChange={(e) => setCountrySubDivisionSearch(e.target.value)}
												style={{ width: '100%' }}
											/>
										</td>
										<td/>
								</tr>
								<tbody>
									{filteredCountrySubdivisions.filter((cs) => editShowAllCountries || cs.country_code === 'US').map((cs) => (
										<tr key={cs.id}>
											<td><input type="checkbox" checked={editSubdivisions.includes(cs.id!)} onChange={(e) => setEditSubdivisions((prev) => (e.target.checked ? [...prev, cs.id!] : prev.filter((id) => id !== cs.id)))} /></td>
											<td>{cs.name}</td>
											<td>{cs.country_code}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
							<Button size="sm" color="light" className="rounded px-2 py-1" onClick={() => setShowEditModal({ fabric: null, show: false })}>Cancel</Button>
							<Button
								size="sm"
								color="light"
								className="rounded px-2 py-1"
								onClick={() => {
									if (showEditModal.fabric) {
										const fabricId = showEditModal.fabric.fabric_id;
										const payload = [{
											fabric_id: fabricId,
											fabric_name: showEditModal.fabric.fabric_name,
											disallowed_country_subdivision_ids: editSubdivisions
										}];
										apiCalls
											.updateFabricDisallowedCountrySubdivisions([...payload])
											.then(() => {
												getAndSetData();
												setShowEditModal({ fabric: null, show: false });
											});
									} else {
										setShowEditModal({ fabric: null, show: false });
									}
								}}
							>
								Save
							</Button>
						</div>
					</div>
				</div>
			)}

			{/* View Modal */}
			{showViewModal.show && showViewModal.fabric && (
				<div className="modal-holder">
					<div className="standard-modal">
						<h3>
							Disallowed Subdivisions for &quot;
							{showViewModal.fabric.fabric_name}
							&quot;
						</h3>
						{
							showViewModal.fabric.disallowed_country_subdivision_ids.length === 0 ? (
								<p>No disallowed subdivisions.</p>
							) : <ul>
								{showViewModal.fabric.disallowed_country_subdivision_ids.map((id) => (
									<li key={id}>
										{getSubdivisionName(id)}
										{' '}
										(
										{getSubdivisionCountry(id)}
										)
									</li>
								))}
							</ul>
						}

						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<Button size="sm" color="light" className="rounded px-2 py-1" onClick={() => setShowViewModal({ fabric: null, show: false })}>Close</Button>
						</div>
					</div>
				</div>
			)}

			{/* Clear Modal */}
			{showClearModal.show && showClearModal.fabric && (
				<div className="modal-holder">
					<div className="standard-modal">
						<h3>
							Clear all disallowances for &quot;
							{showClearModal.fabric.fabric_name}
							&quot;?
						</h3>
						<div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
							<Button size="sm" color="light" className="rounded px-2 py-1" onClick={() => setShowClearModal({ fabric: null, show: false })}>Cancel</Button>
							<Button
								size="sm"
								color="light"
								className="rounded px-2 py-1"
								onClick={() => {
									clearFabricDisallowances([showClearModal?.fabric?.fabric_id ?? 0]);
									setShowClearModal({ fabric: null, show: false });
								}}
							>
								Clear
							</Button>
						</div>
					</div>
				</div>
			)}

			{/* Mass Disallow Modal */}
			{showMassDisallowModal && (
				<div className="modal-holder">
					<div className="standard-modal">
						<h3>Disallow Subdivisions for Selected Fabrics</h3>
						<div style={{ maxHeight: 300, overflowY: 'auto', margin: '12px 0' }}>
							<table style={{ width: '100%' }}>
								<thead>
									<tr>
										<th />
										<th>Name</th>
										<th>Country</th>
									</tr>
								</thead>
								<tbody>
									<tr key="search-row">
										<td/>
										<td>
											<input
												type="text"
												placeholder="Search Subdivisions"
												value={countrySubDivisionSearch}
												onChange={(e) => setCountrySubDivisionSearch(e.target.value)}
												style={{ width: '100%' }}
											/>
										</td>
										<td/>
									</tr>
									{filteredCountrySubdivisions.map((cs) => (
										<tr key={cs.id}>
											<td><input type="checkbox" checked={massDisallowSubdivisions.includes(cs.id!)} onChange={(e) => setMassDisallowSubdivisions((prev) => (e.target.checked ? [...prev, cs.id!] : prev.filter((id) => id !== cs.id)))} /></td>
											<td>{cs.name}</td>
											<td>{cs.country_code}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
							<Button size="sm" color="light" className="rounded px-2 py-1" onClick={() => setShowMassDisallowModal(false)}>Cancel</Button>
							<Button
								size="sm"
								color="light"
								className="rounded px-2 py-1"
								onClick={() => {
									assignStatesToFabricDisallowances(selectedFabrics, massDisallowSubdivisions);
									setShowMassDisallowModal(false);
								}}
							>
								Apply
							</Button>
						</div>
					</div>
				</div>
			)}

			{/* Mass Clear Modal */}
			{showMassClearModal && (
				<div className="modal-holder">
					<div className="standard-modal">
						<h3>Are you sure you want to clear all disallowances for the selected fabrics?</h3>
						<div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
							<Button size="sm" color="light" className="rounded px-2 py-1" onClick={() => setShowMassClearModal(false)}>Cancel</Button>
							<Button
								size="sm"
								color="light"
								className="rounded px-2 py-1"
								onClick={() => {
									clearFabricsSelected();
									setShowMassClearModal(false);
								}}
							>
								Clear
							</Button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default FabricDisallowedByStateContent;
